module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '₩',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '₩',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '₩',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '₩',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '₩',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7516911304873',
        variantId: ['42308593942697', '42308593975465'],
        // variantId: ['42308593942697', '42308593975465', '42308594008233'],
        capacity: 2,
        productName: '2kWh 전원 키트',
        name: '기본 키트(2kWh)',
        discountPrice: 5158000,
        originalPrice: 5158000,
        unit: '₩',
        includes: ['2kWh 인산철 배터리 x1', '파워 허브', '케이블 팩'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7516992405673',
        variantId: ['42308871782569', '42308871848105'],
        // variantId: ['42308871782569', '42308871848105', '42308871913641'],
        capacity: 4,
        productName: '4kWh 전원 키트',
        name: '기본 키트(4kWh)',
        discountPrice: 7454000,
        originalPrice: 7454000,
        unit: '₩',
        includes: ['2kWh 인산철 배터리 x2', '파워 허브', '케이블 팩'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7516994109609',
        variantId: ['42308882530473', '42308882563241'],
        // variantId: ['42308882530473', '42308882563241', '42308882596009'],
        capacity: 5,
        productName: '5kWh 전원 키트',
        name: '기본 키트(5kWh)',
        discountPrice: 7800000,
        originalPrice: 7800000,
        unit: '₩',
        includes: ['5Kwh 인산철 배터리 x1', '파워 허브', '케이블 팩'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7516994896041',
        variantId: ['42308890788009', '42308890820777'],
        // variantId: ['42308890788009', '42308890820777', '42308890853545'],
        capacity: 10,
        productName: '10kWh 전원 키트',
        name: '기본 키트(10kWh)',
        discountPrice: 12642000,
        originalPrice: 12642000,
        unit: '₩',
        includes: ['5Kwh 인산철 배터리 x2', '파워 허브', '케이블 팩'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7516995682473',
        variantId: ['42308896096425', '42308896129193'],
        // variantId: ['42308896096425', '42308896129193', '42308896161961'],
        capacity: 15,
        productName: '15kWh 전원 키트',
        name: '기본 키트(15kWh)',
        discountPrice: 17755000,
        originalPrice: 17755000,
        unit: '₩',
        includes: ['5Kwh 인산철 배터리 x3', '파워 허브', '케이블 팩'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: '콤보를 선택하여 사용 환경을 개선하세요.',
      discountPrice: 300,
      originalPrice: 538,
      unit: '₩',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'AC/DC 스마트 배전 패널',
        desc: '12개의 퓨즈 DC 포지션과 6개의 AFCI 보호 AC 포지션을 통해 RV 또는 소형 주택의 배전을 관리할 수 있습니다. 에코플로우 앱 또는 콘솔에서 최대 6개의 DC 포지션을 제어할 수 있습니다.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'AC/DC 스마트 배전 패널',
          desc: '12개의 퓨즈 DC 포지션과 6개의 AFCI 보호 AC 포지션을 통해 RV 또는 소형 주택의 배전을 관리할 수 있습니다. 에코플로우 앱 또는 콘솔에서 최대 6개의 DC 포지션을 제어할 수 있습니다.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC 주 입력',
            value: '최대 30A, 120V, 3600W'
          }, {
            key: 'DC 주 입력',
            value: '최대 70A'
          }, {
            key: 'AC 출력',
            value: '6 AC 포지션, 각 최대 20A'
          }, {
            key: 'DC 출력',
            value: '12 퓨즈 DC 포지션 (파워 키트 콘솔 및 앱을 통해 제어할 수 있는 6 * 포지션)'
          }, {
            key: '작동 온도',
            value: '-25°C~60°C(-13°F~140°F)'
          }, {
            key: '크기',
            value: '18.03 x 35.56 x 8.89cm(7.1 x 14 x 3.5in)(높이 x 너비 x 깊이)'
          }, {
            key: '순 중량',
            value: '3.49kg(7.7lbs)'
          }, {
            key: '보호 수준',
            value: 'IP21'
          }, {
            key: '시험 및 인증',
            value: 'CE, UL, FCC, EMC Class B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: '마운팅 스트랩',
        desc: '배터리를 더 안전하고 강력하게 장착할 수 있습니다.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }
    // {
    //     productId: 2,
    //     variantId: '',
    //     name: 'Add power, control your system, and monitor energy usage.',
    //     discountPrice: 1600,
    //     originalPrice: 2355,
    //     unit: '₩',
    //     subs: [
    //         {
    //             comboSubId: 'combo_2_sub_1',
    //             name: 'AC/DC 스마트 배전 패널',
    //             desc: '12개의 퓨즈 DC 포지션과 6개의 AFCI 보호 AC 포지션을 통해 RV 또는 소형 주택의 배전을 관리할 수 있습니다. 에코플로우 앱 또는 콘솔에서 최대 6개의 DC 포지션을 제어할 수 있습니다.',
    //             img: '/img/calculators/mm100/combo-distribution.jpg',
    //             imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
    //             details: {
    //                 title: 'AC/DC 스마트 배전 패널',
    //                 desc: '12개의 퓨즈 DC 포지션과 6개의 AFCI 보호 AC 포지션을 통해 RV 또는 소형 주택의 배전을 관리할 수 있습니다. 에코플로우 앱 또는 콘솔에서 최대 6개의 DC 포지션을 제어할 수 있습니다.',
    //                 img: '/img/calculators/mm100/combo-detail-distribution.jpg',
    //                 imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
    //                 specParams: [
    //                     {
    //                         key: 'AC 주 입력', value: '최대 30A, 120V, 3600W'
    //                     },
    //                     {
    //                         key: 'DC 주 입력', value: '최대 70A'
    //                     },
    //                     {
    //                         key: 'AC 출력', value: '6 AC 포지션, 각 최대 20A'
    //                     },
    //                     {
    //                         key: 'DC 출력', value: '12 퓨즈 DC 포지션 (파워 키트 콘솔 및 앱을 통해 제어할 수 있는 6 * 포지션)'
    //                     },
    //                     {
    //                         key: '작동 온도', value: '-25°C~60°C(-13°F~140°F)'
    //                     },
    //                     {
    //                         key: '크기', value: '18.03 x 35.56 x 8.89cm(7.1 x 14 x 3.5in)(높이 x 너비 x 깊이)'
    //                     },
    //                     {
    //                         key: '순 중량', value: '3.49kg(7.7lbs)'
    //                     },
    //                     {
    //                         key: '보호 수준', value: 'IP21'
    //                     },
    //                     {
    //                         key: '시험 및 인증', value: 'CE, UL, FCC, EMC Class B'
    //                     },
    //                 ]
    //             }
    //         },
    //         {
    //             comboSubId: 'combo_2_sub_2',
    //             name: '에코플로우 파워 키트 콘솔',
    //             desc: '모니터를 사용하여 전력 소비량을 제어, 모니터링, 확인합니다.',
    //             img: '/img/calculators/mm100/combo-console.jpg',
    //             imgH5: '/img/calculators/mm100H5/combo-console.jpg',
    //             details: {
    //                 title: '에코플로우 파워 키트 콘솔',
    //                 desc: '모니터를 사용하여 전력 소비량을 제어, 모니터링, 확인합니다.',
    //                 img: '/img/calculators/mm100/combo-detail-console.jpg',
    //                 imgH5: '/img/calculators/mm100H5/combo-console.jpg',
    //                 specParams: [
    //                     { key: '터치 스크린(대각)', value: '7인치' },
    //                     { key: '전원 공급 전압', value: '12 VDC' },
    //                     { key: '작동 온도', value: '-25°C~60°C(-13°F~140°F)' },
    //                     { key: '크기', value: '11.43 x 20.57 x 2.28cm(4.5 x 8.1 x 0.9in)(높이 x 너비 x 깊이)' },
    //                     { key: '순 중량', value: '0.49kg(1.1lbs)' },
    //                     { key: '시험 및 인증', value: 'CE, UL, FCC, EMC Class B' },
    //                 ]
    //             }
    //         },
    //         {
    //             comboSubId: 'combo_2_sub_3',
    //             name: '스마트 발전기',
    //             desc: '극단적인 경우 스마트 발전기를 보조 전원으로 사용할 수 있습니다. 스마트 발전기는 다른 선택의 여지가 없을 때 그러한 장치를 충전하기 위해 사용됩니다. 또한 다른 발전기보다 최대 25% 더 효율적이므로 연료, 가스, 시간을 절약할 수 있습니다.',
    //             img: '/img/calculators/mm100/combo-generator.jpg',
    //             imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
    //             details: {
    //                 title: '스마트 발전기',
    //                 desc: '극단적인 경우 스마트 발전기를 보조 전원으로 사용할 수 있습니다. 스마트 발전기는 다른 선택의 여지가 없을 때 그러한 장치를 충전하기 위해 사용됩니다. 또한 다른 발전기보다 최대 25% 더 효율적이므로 연료, 가스, 시간을 절약할 수 있습니다.',
    //                 img: '/img/calculators/mm100/combo-detail-generator.jpg',
    //                 imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
    //                 specParams: [
    //                     { key: '순 중량', value: '28.45kg(62.8lbs)' },
    //                     { key: '크기', value: '59.69 x 29.71 x 47.49cm(23.5 x 11.7 x 18.7in)' },
    //                     { key: '정격 전압', value: '100~120V / 200~240V' },
    //                     { key: '유형', value: '인버터 발전기' },
    //                     { key: '주파수', value: '60Hz' },
    //                     { key: '정격 출력 전원', value: '1800W(피크 1900W)' },
    //                     { key: '연료 유형', value: '무연 연료' },
    //                     { key: '연료 탱크 부피', value: '4L(1.06gal)' },
    //                     { key: '연속 작동 시간', value: '3.5시간(최대 부하)' },
    //                 ]
    //             }
    //         },
    //         {
    //             comboSubId: 'combo_2_sub_4',
    //             name: '마운팅 스트랩',
    //             desc: '배터리를 더 안전하고 강력하게 장착할 수 있습니다.',
    //             img: '/img/calculators/mm100/combo-strap.jpg',
    //             imgH5: '/img/calculators/mm100H5/combo-strap.jpg',
    //         },
    //     ],
    // },
    ],

    // solar panel
    solarPack: [{
      productId: '7516998795433',
      variantId: '42308918640809',
      name: '2*100W 고정식 태양광 패널+2*고정식 태양광 마운팅 피트',
      discountPrice: 251000,
      originalPrice: 251000,
      // discountRate: 0.8,
      unit: '₩',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*100W 고정식 태양광 패널+2*고정식 태양광 마운팅 피트',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: '정격 전력',
          value: '100W(+/-5W)'
        }, {
          key: '개회로 전압',
          value: '20.3V'
        }, {
          key: '단락 전류',
          value: '6.3A'
        }, {
          key: '최대 작동 전압',
          value: '17.1V'
        }, {
          key: '최대 작동 전류',
          value: '5.9A'
        }, {
          key: '정격 전력의 온도 계수',
          value: '-0.39 % /°C'
        }, {
          key: '개회로 전압의 온도 계수',
          value: '-0.33 % /°C'
        }, {
          key: '단락 전류의 온도 계수',
          value: '0.06 % /°C'
        }, {
          key: '최대 시스템 전압',
          value: '600 VDC (UL)'
        }, {
          key: '최대 퓨즈 전류',
          value: '15A'
        }, {
          key: '태양광 패널 무게',
          value: '약 6.2kg(13.7lbs) '
        }, {
          key: '크기',
          value: '98 * 58.6 * 3cm (38.6*23.1*1.2인치)'
        }]
      },
      question: {}
    }, {
      productId: '7516998795433',
      variantId: '42308918673577',
      name: '2*400W 고정식 태양광 패널+4*고정식 태양광 마운팅 피트',
      discountPrice: 847000,
      originalPrice: 847000,
      // discountRate: 0.8,
      unit: '₩',
      number: 0,
      capacity: 800,
      freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*400W 고정식 태양광 패널+4*고정식 태양광 마운팅 피트',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: '정격 전력',
          value: '400W(+/-3W) '
        }, {
          key: '개회로 전압',
          value: '37.10V'
        }, {
          key: '단락 전류',
          value: '13.79A'
        }, {
          key: '최대 작동 전압',
          value: '31.00V'
        }, {
          key: '최대 작동 전류',
          value: '12.9A'
        }, {
          key: '정격 전력의 온도 계수',
          value: '-0.38%/°C'
        }, {
          key: '개회로 전압의 온도 계수',
          value: '-0.35%/°C'
        }, {
          key: '단락 전류의 온도 계수',
          value: '0.06%/°C'
        }, {
          key: '최대 시스템 전압',
          value: '1500 VDC(UL)'
        }, {
          key: '최대 퓨즈 전류',
          value: '25A'
        }, {
          key: '작동 온도',
          value: '-20°C-+50°C'
        }, {
          key: '태양광 패널 무게',
          value: '약 21.8kg(48lbs)'
        }, {
          key: '크기',
          value: '1722x1134x35mm'
        }]
      },
      question: {}
    }, {
      productId: '7516999745705',
      variantId: '42308923424937',
      name: '1*100W 플렉시블 태양광 패널',
      discountPrice: 295000,
      originalPrice: 295000,
      // discountRate: 0.8,
      unit: '₩',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*100W 플렉시블 태양광 패널',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: '정격 전력',
          value: '100W(+/-5W)'
        }, {
          key: '개회로 전압',
          value: '20.3V'
        }, {
          key: '단락 전류',
          value: '6.3A'
        }, {
          key: '최대 작동 전압',
          value: '17.1V'
        }, {
          key: '최대 작동 전류',
          value: '5.9A'
        }, {
          key: '정격 전력의 온도 계수',
          value: '-0.39 % /°C'
        }, {
          key: '개회로 전압의 온도 계수',
          value: '-0.33 % /°C'
        }, {
          key: '단락 전류의 온도 계수',
          value: '0.06 % /°C'
        }, {
          key: '최대 시스템 전압',
          value: '600 VDC (UL)'
        }, {
          key: '최대 퓨즈 전류',
          value: '15A'
        }, {
          key: '태양광 패널 무게',
          value: '약 2.3kg(5.1lbs) '
        }, {
          key: '크기',
          value: '1, 055* 612 * 25mm (41.5*24.1*1.0인치)'
        }]
      },
      question: {}
    }, {
      productId: '7517000663209',
      variantId: '41998639202473',
      name: '1*400W 휴대용 태양광 패널',
      discountPrice: 1250000,
      originalPrice: 1390000,
      // discountRate: 0.8,
      unit: '₩',
      number: 0,
      capacity: 400,
      locale: ['us', 'ca', 'au', 'jp', 'kr'],
      // only for xx site
      img: '/img/calculators/mm100/solar-400-portable.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*400W 휴대용 태양광 패널',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
        specParams: [{
          key: '정격 전력',
          value: '400W(+/- 10W)*'
        }, {
          key: '개회로 전압',
          value: '48V (Vmp 41V)'
        }, {
          key: '단락 전류',
          value: '11A (Imp 9.8A)'
        }, {
          key: '효율성',
          value: '22.4%'
        }, {
          key: '셀 유형',
          value: '단결정 실리콘'
        }, {
          key: '커넥터 유형',
          value: 'MC4'
        }, {
          key: '중량',
          value: '46.3파운드(21KG)'
        }, {
          key: '태양광 패널',
          value: '33.1파운드(15KG)'
        }, {
          key: '펼쳐진 치수',
          value: '42.0*94.1*1.0인치(106.8*239.0*2.4cm)'
        }, {
          key: '접힌 치수',
          value: '42.0*24.4*1.0인치(106.8*62.0*2.4cm)'
        }]
      },
      question: {}
    }],
    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      42308593942697: 'power-2kw.jpg',
      42308593975465: 'bundle-2kw-dp.jpg',
      42308594008233: 'bundle-2kw-all.jpg',
      42308871782569: 'power-4kw.jpg',
      42308871848105: 'bundle-4kw-dp.jpg',
      42308871913641: 'bundle-4kw-all.jpg',
      42308882530473: 'power-5kw.jpg',
      42308882563241: 'bundle-5kw-dp.jpg',
      42308882596009: 'bundle-5kw-all.jpg',
      42308890788009: 'power-10kw.jpg',
      42308890820777: 'bundle-10kw-dp.jpg',
      42308890853545: 'bundle-10kw-all.jpg',
      42308896096425: 'power-15kw.jpg',
      42308896129193: 'bundle-15kw-dp.jpg',
      42308896161961: 'bundle-15kw-all.jpg'
    },
    // solar price discount rate
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7516911304873: {
        original: [0, 585000],
        discount: [0, 585000]
      },
      7516992405673: {
        original: [0, 612000],
        discount: [0, 612000]
      },
      7516994109609: {
        original: [0, 585000],
        discount: [0, 585000]
      },
      7516994896041: {
        original: [0, 838000],
        discount: [0, 838000]
      },
      7516995682473: {
        original: [0, 560000],
        discount: [0, 560000]
      }
    },
    // common power kit's details
    powerDetails: {
      title: '에코플로우 파워 허브',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: '파워 허브는 파워 키트의 심장이라 할 수 있습니다. 두 개의 MPPT 태양광 충전 컨트롤러, 한 개의 MPPT 배터리 충전기, 한 개의 DC-DC 강하 컨버터, 인버터-충전기를 하나로 처리합니다. 이를 통해 카라반 또는 야외에서 사용 시 귀중한 공간을 절약할 수 있으며, 설치가 간단해집니다.',
      specParams: [{
        key: '순 중량',
        value: '14.06kg(31lbs)'
      }, {
        key: '크기',
        value: '29.97*48.00*13.97cm(11.8*18.9*5.5in)(높이x너비x깊이）'
      }, {
        key: '시험 및 인증',
        value: 'CE, UL, FCC'
      }, {
        key: 'WI-FI',
        value: '지원'
      }, {
        key: 'Bluetooth',
        value: '지원'
      }, {
        key: 'AC 주 출력/주파수',
        value: '순수 정현파，3600W（서지 6000W），120V~, 50Hz/60Hz'
      }, {
        key: 'DC 주 출력',
        value: '13.6V/70A 최대 1000W, 26.4V/60A，최대 1500W '
      }, {
        key: 'AC 주 입력',
        value: 'X-Stream 고속 충전 최대 3000W，최대 30A'
      }, {
        key: 'AC 주 입력 전압/주파수',
        value: '100~120V~, 50Hz/60Hz'
      }, {
        key: '태양광 충전 입력',
        value: '15~150V 30A，최대 1000W'
      }, {
        key: '교류 발전기 충전 입력',
        value: '13V 60A，최대 1000W'
      }, {
        key: '최적 작동 온도',
        value: '20°C~30°C(68°F~86°F)'
      }, {
        key: '방전 온도',
        value: '-25°C~60°C(-13°F~140°F)'
      }, {
        key: '충전 온도',
        value: '-25°C~60°C(-13°F~140°F)'
      }, {
        key: '보관 온도',
        value: '-25°C~60°C(-13°F~140°F)'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: '늘어난 작동 시간은 태양광 패널 입력의 평균 80%와 평균 5시간 햇빛을 기준으로 계산되었습니다.'
    },
    // installations
    installOptions: [{
      variantId: 0,
      i18n: 'self'
    }, {
      productId: '7517009019049',
      variantId: '42308972871849',
      i18n: 'expert',
      i18n_des: 'pro'
    }],
    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: '파워 허브 + 마운팅 스트랩'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};